import { OverlayView } from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';
import { IconMarker } from '../../../../Common/Icon';

import styles from './index.module.scss';

interface CountryStatMarkerProps {
  position: { lat: number; lng: number };
  value: number | string;
  internationalId: string;
}

export default function CountryStatMarker({
  position,
  value,
  internationalId,
}: CountryStatMarkerProps) {
  const navigate = useNavigate();

  if (!position) {
    return null;
  }

  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        className={styles.marker}
        onClick={() => navigate(`/international/${internationalId}`)}
      >
        <IconMarker className={styles.icon} />
        <div className={styles.value}>{value}%</div>
      </div>
    </OverlayView>
  );
}
